<template>
    <div class="paper-card flex flex-col gap-4 rounded border border-solid border-grey-40 bg-white px-6 py-4">

        <div class="flex items-center gap-4">

            <span class="shrink-0 text-xl font-semibold text-black">
                {{ title }}
            </span>

            <div class="th-tooltip" :data-tip="t('patentApplicationTrendTip')">
                <PtIcon icon="SolidInfo" class="fill-grey-55 text-2xl" />
            </div>

            <i class="grow"></i>

            <button @click="downloadChartAsImage" :disabled="disableUI" class="th-btn th-btn-plain shrink-0">
                <PtIcon class="th-btn-icon fill-grey-450 text-2xl" icon="SolidExport" />
                <span>{{ t('download') }}</span>
            </button>

        </div>

        <div class="h-[548px]">
            <BIChart ref="patentTrendChart"
                     :chartKey="chartKey"
                     :isLoading="isFetchLoading"
                     :configTaskFunc="chartConfig"
                     :dataTaskFunc="getPatentChartData"
                     @click="handleDrillDown"
                     class="h-full w-full" />
        </div>
    </div>
</template>

<script setup lang="ts">
import '@patsnap-ui/icon/assets/VectorGradient.svg';

import { PtIcon } from 'patsnap-biz';
import BIChart from '@/components/BIChart.vue';
import { ref } from 'vue'
import { usePatentTrend } from '@/composables/use-patent-trend';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const patentTrendChart = ref<{
  generateChartImage: () => Promise<string>,
  drawChart: () => void,
  isChartLoaded: () => boolean
  isEmptyChart: boolean
}>();

const {
    disableUI,
    chartKey,
    chartConfig,
    isFetchLoading,
    getPatentChartData,
    downloadChartAsImage,
    handleDrillDown,
    title,
} = usePatentTrend(patentTrendChart);

</script>

<style lang="scss">
.paper-card-tips {
  background: linear-gradient(95deg, rgba(219, 234, 255, 0.30) 6.07%, rgba(228, 231, 255, 0.30) 100%);
}
</style>
